
import Store from './Store';
import AuthenticationStore from './AuthenticationStore';

export {default as Store} from './Store';
export {default as AuthenticationStore} from './AuthenticationStore';

export const authenticationStore = new AuthenticationStore();
export default new Store();
